import { useScrolled } from '@/hooks/useScrolled';
import { scrollToTop } from '@/lib/scroll';
import styles from './BackToTop.module.css';

/**
 * Returns the visitor to the top of a long view.
 *
 * The tools grid runs to 27 cards and the Q&A thread grows without bound, so
 * the header — which is sticky but shallow — is not always enough. Hidden until
 * there is meaningfully far to scroll back.
 */
export function BackToTop() {
  const scrolled = useScrolled(600);

  const toTop = () => {
    scrollToTop();
    document.getElementById('main')?.focus({ preventScroll: true });
  };

  return (
    <button
      type="button"
      className={`${styles.button} ${scrolled ? styles.visible : ''}`}
      onClick={toTop}
      aria-label="العودة إلى أعلى الصفحة"
      title="العودة إلى أعلى الصفحة"
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        focusable="false"
      >
        <path d="M12 19V5M5 12l7-7 7 7" />
      </svg>
    </button>
  );
}
